import React, {Component} from "react";
import {Form, Input , Radio,Row,Col,Checkbox,InputNumber,Upload,message,Spin,Icon,Modal } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import {createUuid} from "../../../utils/NHCore";
const Dragger = Upload.Dragger;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

/**
 * 绿色通道编辑表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewImage:'',
            previewVisible: false,
            fileList: [],
            uploading:false,
            checkedOptions:[],
            defaultChecked:[],
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            showList: [],//展示办理原因
            blYyList: [],//总办理原因
            sqlyFlag: false, //申请理由flag
            blYyChecked: '',//选中的办理原因
            lstdhjid:'',
        }
    }

    componentDidMount(){
        let initFormData = this.props.initFormData;
        if(initFormData.PKID) {
            this.loadfileList(initFormData.PKID);
        }
        this.loadLstdBlyy('AHGS_YXXT_LSTD_BLYY');//获取办理原因
    }

    // 获取办理原因
    loadLstdBlyy = (dmbz) => {
        NHFetch('api/zhxg-yxwz/openapi/yxwz/getDmk', "GET", { dmbz: dmbz })
            .then(res => {
                if (!res || res.code !== 200) return message.error('系统繁忙，请联系管理员!')
                // 设置默认展示免缴学费
                const list = res.data.filter(item => {
                    return item.FDM == 1;
                })
                this.setState({ blYyList: res.data, showList: list })
            });
    }


    loadfileList=(pkid)=>{
        NHFetch(`/swbl/lstd/${pkid}/getFjList`,'get').then(res=>{
            if(res){
                let fileList = [];
                if(res.data && res.data.length>0){
                    res.data.map((elem,index)=>{
                        //格式化对于附件取值
                        let file = {
                            uid: elem.fjid,
                            name: elem.fjmc,
                            response:{
                                data:{
                                    ssbh:elem.fjid,
                                    fjmc:elem.fjmc,
                                }
                            },
                            status: 'done'
                        }
                        fileList.push(file);
                    })
                }
                this.setState({fileList:fileList});
                this.props.form.setFieldsValue({fj:{fileList:this.state.fileList}});
            }
        });
    }


    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        } else {
            return true;
        }
    }

    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });

    remove=(ssbh)=>{
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url,"POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }

    handleChange = ({ fileList } ) => {
        let count = 0;
        fileList.map((elem)=>{
            if(elem && elem['status'] && elem['status']==='uploading'){
                this.setState({uploading:true});
                return;
            }else if(elem && elem['status']){
                count++;
            }
        })
        if(count>0){
            this.setState({uploading:false});
        }
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    // 转化base64
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    // 下载文件
    handlePreview = (file) => {
       window.open(`/anonymity/docrepo/download/file?attachmentId=${fjid}`);
    };

    // 选择办理方式
    onChange = (event) => {
        const { blYyList } = this.state;
        const list = blYyList.filter(item => {
            return item.FDM == event.target.value;
        })
        const flag = event.target.value == 2
        this.props.form.setFieldsValue({ blyy: null });//重置办理原因选中值
        this.setState({ showList: list, sqlyFlag: flag, blYyChecked: '' })
    }
    // 选择办理原因
    onChange1 = (event) => {
        // console.log('测试:', event.target.value)
        this.setState({ blYyChecked: event.target.value })
    }

    render() {
        const {form,initFormData} = this.props;
        const {showList,blYyChecked,sqlyFlag} =this.state;
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        const props = {
            name: 'file',
            action: '/anonymity/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },
            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList
                    };
                },()=>{
                    if(file.response && file.response.data && file.response.data.ssbh){
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if(!this.beforeUpload(file)){
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange:file=>{this.handleChange(file)},
            onPreview: this.handlePreview,
            fileList:this.state.fileList,
        };
        const checkedOptions = this.state.checkedOptions;
        return (
            <div>
                <div style={{display:'none'}}>
                    <NHFormItem id={"pkid"}
                        form={this.props.form}
                        initialValue={initFormData.PKID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"xsid"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.XSID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"nd"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.ND}>
                        <Input />
                    </NHFormItem>
                </div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>
                        {initFormData.PKID?'':<span style={{marginRight:'4px',fontFamily:'SimSun',fontSize:'14px',color:'#f5222d'}}>*</span>}
                        姓名(学号)：
                    </Col>
                    <Col span={8}>{initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>

                <div style={{ marginLeft: "30px" }}>
                    <NHFormItem id={'blfs'} required={true} initialValue={1} form={form} formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 16 } }} label="办理方式">
                        <Radio.Group name="radiogroup" onChange={this.onChange}>
                            <Radio value={1}>免缴学费</Radio>
                            <Radio value={2}>缓缴学费</Radio>
                        </Radio.Group>
                    </NHFormItem>
                    <NHFormItem id={'dklx'} required={true} initialValue={null} form={form} formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 16 } }} label="办理原因">
                        <Radio.Group name="radiogroup" onChange={this.onChange1}>
                            {
                                showList.map(item => {
                                    return <Radio value={item.DM} key={item.PXH}>{item.MC}</Radio>
                                })
                            }
                        </Radio.Group>
                    </NHFormItem>
                </div>
                <div className="form_item" style={{ marginLeft: '7%' }}>
                    {sqlyFlag && <NHFormItem id={'sqsm'} required={true} initialValue={initFormData.SQSM} form={form} formItemLayout={formItemLayout} label="申请理由">
                        <TextArea style={{ width: '20%' }} maxLength={50} placeholder="请填写申请理由" />
                    </NHFormItem>}
                    {(blYyChecked && blYyChecked === 'syddk') && <div>
                        <NHFormItem id={'blje'} initialValue={initFormData.BLJE} form={form} formItemLayout={formItemLayout} label="贷款金额">
                            <InputNumber style={{ width: '20%' }} min={0} max={9999999} precision={0} placeholder="请填写贷款金额（元）" />
                        </NHFormItem>
                        <NHFormItem id={'dkyh'} initialValue={initFormData.DKYH} form={form} formItemLayout={formItemLayout} label="贷款银行">
                            <NHSelect style={{ width: '20%' }} sign={"dmk_yxwz_dkyh"} onChange={(v) => { }} />
                        </NHFormItem>
                        <NHFormItem id={'hzjym'} initialValue={initFormData.HZJYM} form={form} formItemLayout={formItemLayout} label="回执校验码">
                            <Input style={{ width: '20%' }} maxLength={8} placeholder="6位数回执校验码" />
                        </NHFormItem>
                    </div>}
                </div>

                <NHFormItem id={"fj"} label={'上传证明材料'}  hasFeedback={true} form={form}
                            formItemLayout={{labelCol: { span: 4 },wrapperCol: { span: 8 }}}>
                        <Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <Spin spinning={this.state.uploading}/>
                            <p className="ant-upload-text font-14">
                                点击此处或拖拽文件到此
                            </p>
                        </Dragger>
                </NHFormItem>
                <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <img
                        alt="example"
                        style={{ width: '100%' }}
                        src={this.state.previewImage}
                    />
                </Modal>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/swbl/ahgsLstd/EditForm.js